<template>
  <div>

    <form @submit.prevent="createGame()">
      <div>
        Room Name
      </div>
      <div>
        <input type="text" @change="toSlug" v-model="newGame.displayName" class="text-input" style="width: calc(100% - 10px * 2.0);" />
      </div>
      <!-- <div>
        {{ newGame.slug }}
      </div> -->

      <div>
        Room Size
      </div>
      <div>
        <!-- <select v-model="config" class="text-input full-w click">
          <option :key="item.sizeX + '-' + item.sizeY" :value="item" v-for="item in items">Tiles: {{ item.sizeX }}x{{ item.sizeY }}, Best for: {{ item.bestFor }}</option>
        </select> -->
        <select  class="text-input full-w click clickable" v-model="newGame.width" @change="onSizeChange($event.target.value)">
          <option :value="10">10x10, 1-10 players (quickplay)</option>
          <option :value="15">15x15, 10-15 players (quickplay)</option>
          <option :value="20">20x20, 15-20 players (quickplay)</option>
          <option :value="25">25x25, 1-30 players</option>
          <option :value="50">50x50, 30-70 players</option>
          <option :value="75">75x75, 70-100 players</option>
          <option :value="100">100x100, 100-150 players</option>
          <option :value="125">125x125, 100-170 players</option>
          <option :value="150">150x150, 100-200 players</option>
          <!-- <option :value="500">500x500, 500-700 players</option> -->
        </select>
      </div>
      <div>
        Enable Password:
      </div>
      <div class="vly-center">
        <img class="click m-right-10" src="../img/box.svg" v-if="!newGame.enableEntryPassword" alt="" @click="newGame.enableEntryPassword = !newGame.enableEntryPassword;">
        <img class="click m-right-10" src="../img/box-ok.svg" v-if="newGame.enableEntryPassword" alt="" @click="newGame.enableEntryPassword = !newGame.enableEntryPassword;">
        <!-- <span style="margin-left: 10px;">?</span> -->
        <input type="password" :disabled="!newGame.enableEntryPassword" v-model="newGame.entryPassword" class="m-left text-input full-w" style="margin-right: 0px;" />
      </div>
      <div class="vh-center">
        <input class="text-input primary click" @click="createGame()" value="Create My Room" type="submit">
      </div>

      <!--
      <input type="text" v-model="newGame.displayName" @input="toSlug" @change="toSlug" />
      <div>
        <input type="checkbox" v-model="newGame.enableEntryPassword">
        <input type="text" placeholder="Entry Passwrod" v-model="newGame.entryPassword">
      </div>
      -->

    </form>
  </div>
</template>

<script>
import * as sAPI from '../api/strapi.js'
import slug from 'slug'
export default {
  data () {
    return {
      newGame: {
        displayName: '',
        slug: '',

        width: 10,
        height: 10,

        enableEntryPassword: false,
        entryPassword: '',
        question: {
          easy: ``,
          medium: ``,
          hard: ``
        },
        flags: {
          variant: 'buhk'
        }
      },
      gameSecret: false,
      game: false,
      map: false
    }
  },
  methods: {
    onSizeChange (val) {
      this.newGame.width = val
      this.newGame.height = val
    },
    async toSlug () {
      this.newGame.slug = slug(this.newGame.displayName)
      let canUse = await sAPI.checkDuplicateSlug({ slug: this.newGame.slug })
      if (!canUse) {
        this.newGame.slug = slug(this.newGame.displayName) + `-${Number(Math.random() * 1000).toFixed(0)}`
      }
    },
    async createGame () {
      this.game = await sAPI.createGame({
        width: this.newGame.width,
        height: this.newGame.height,
        enableEntryPassword: this.newGame.enableEntryPassword,
        userID: sAPI.LS.UserID,
        question: this.newGame.question,
        flags: this.newGame.flags,
        displayName: this.newGame.displayName,
        slug: this.newGame.slug
      })

      let gameID = this.game._id
      this.gameSecret = await sAPI.setRoomPassword({
        gameID,
        userID: sAPI.LS.UserID,
        entryPassword: this.newGame.entryPassword || ''
      })

      this.$emit('ok', {
        game: this.game,
        gameSecret: this.gameSecret
      })
    }
  }
}
</script>

<style scoped>
.full-w {
  width: 100%;
}
.text-input{
  appearance: none;
  box-shadow: none;
  border: #ccc solid 1px;
  border-radius: 10px;
  outline: none;
  padding: 10px;
  margin: 10px;
  margin-left: 0px;
  background-color: #F0EFEF;
}

.vh-center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.vly-center{
  display: flex;
  align-items: center;
}
</style>
